import type { BusinessPackageId, PackageId, SubscriptionType } from '../types';
import {
  BUSINESS_ANNUAL,
  BUSINESS_MONTHLY,
  FAMILY_ANNUAL,
  FAMILY_MONTHLY,
  PLUS_ANNUAL,
  PLUS_MONTHLY,
} from './getRedirectUrl';
import { BUSINESS_PRICES } from './seatPacks';

export type PlanPricing<Id extends PackageId = PackageId> = {
  price: string;
  period: string;
  packageId: Id;
};

// Display prices per billing interval, paired with the package the CTA checks
// out. Shared by the inline upgrade choices in settings and the compare-plans
// modal so the two surfaces can't quote different numbers. The amounts billed
// are the Stripe prices configured on the server.
export const PLUS_PRICING: Record<
  SubscriptionType,
  PlanPricing<'PLUS_ANNUAL' | 'PLUS_MONTHLY'>
> = {
  yearly: { price: '$30', period: '/year', packageId: PLUS_ANNUAL },
  monthly: { price: '$5', period: '/month', packageId: PLUS_MONTHLY },
};

export const FAMILY_PRICING: Record<
  SubscriptionType,
  PlanPricing<'FAMILY_ANNUAL' | 'FAMILY_MONTHLY'>
> = {
  yearly: { price: '$60', period: '/year', packageId: FAMILY_ANNUAL },
  monthly: { price: '$10', period: '/month', packageId: FAMILY_MONTHLY },
};

// Business prices come from the seat-pack price map so the card, its feature
// copy, and the seat stepper can never disagree.
export const BUSINESS_PRICING: Record<
  SubscriptionType,
  PlanPricing<BusinessPackageId>
> = {
  yearly: {
    price: `$${BUSINESS_PRICES.yearly.base}`,
    period: '/year',
    packageId: BUSINESS_ANNUAL,
  },
  monthly: {
    price: `$${BUSINESS_PRICES.monthly.base}`,
    period: '/month',
    packageId: BUSINESS_MONTHLY,
  },
};
